<template>
  <div class="pay-trans-details">
    <div class="filter-right-container">
      <div class="filter-container-tag">
        {{ $t('components.activity') }}
      </div>
      <el-popover
        placement="bottom"
        trigger="click"
      >
        <div class="filter-section-container">
          <div id="filter-content" class="filter-content">
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('merchantAccount.create_time') }}</div>
              <el-date-picker
                v-model="search.times"
                class="filter-item-value"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
              />
            </div>
            <div class="filter-item">
              <div class="filter-item-label">
                {{ $t('merchantAccount.complete_time') }}
              </div>

              <el-date-picker
                v-model="search.response_times"
                class="filter-item-value"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
              />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('merchant.payment_channel') }}</div>
              <el-select v-model="search.channel_code" filterable class="filter-item-value" clearable>
                <el-option
                  v-for="(item,index) in compFilterPaymentChannel"
                  :key="index"
                  :label="item.channel_code"
                  :value="item.channel_code"
                />
              </el-select>
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('merchantAccount.transaction_status') }}</div>
              <el-select v-model="search.transaction_status" class="filter-item-value" clearable>
                <el-option
                  v-for="(item,index) in payTransactionStatusArr"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('data.settlement_status') }}</div>
              <el-select v-model="search.settlement_status" class="filter-item-value" clearable>
                <el-option
                  v-for="(item,index) in transactionSettlementStatusMap"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.transaction_id') }}</div>
              <el-input v-model="search.transaction_id" type="text" class="filter-item-value" clearable />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.merchant_order_id') }}</div>
              <el-input v-model="search.merchant_order_id" type="text" class="filter-item-value" clearable />
            </div>
            <!-- <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.payment_code') }}</div>
              <el-input v-model="search.payment_code"  type="text" class="filter-item-value" clearable />
            </div> -->

            <div class="filter-item">
              <!-- <div class="filter-item-label">{{ $t('customerService.app_name') }}</div>
              <el-input v-model="search.app_name"  type="text" class="filter-item-value" clearable /> -->
            </div>
            <div class="filter-item">
              <!-- <div class="filter-item-label">{{ $t('customerService.payer_mobile') }}:</div>
              <el-input v-model="search.payer_mobile"  type="text" class="filter-item-value" clearable /> -->
            </div>
          </div>
          <div class="filter-operate">
            <div class="filter-operate-right">
              <el-button class="search-btn mb-10" @click="onClickReset">{{ $t('components.clear') }}</el-button>
              <el-button class="search-btn mb-10" type="primary" icon="el-icon-search" @click="handleFilter">{{ $t('components.search') }}</el-button>
            </div>

          </div>
        </div>
        <el-button slot="reference" class="mb-10 mr-12" type="info" plain>   <svg-icon class-name="mr-10" icon-class="filter" />{{ $t('components.filter') }}</el-button>
      </el-popover>
      <el-button class="mb-10 download-btn" plain :loading="downloading" type="info" @click="onClickDowmloadBtn"><svg-icon icon-class="download" /> {{ $t('components.download') }}</el-button>
    </div>

    <div class="total-container">
      <div class="total-item">
        <div class="total-item-text"> {{ $t('data.total_count') }}</div>
        <div class="color-main-linear-blue total-item-num">{{ total_count }}</div>
      </div>
      <div class="total-item">
        <div class="total-item-text"> {{ $t('data.total_amount') }}</div>
        <div class="color-main-linear-blue total-item-num">{{ $store.getters.currency }}  {{ total_amount | toDivideWithDot }}</div>
      </div>
      <div class="total-item">
        <div class="total-item-text"> {{ $t('data.total_fee') }}</div>
        <div class="color-main-linear-blue total-item-num">{{ $store.getters.currency }}  {{ total_fee | toDivideWithDot }}</div>
      </div>
    </div>
    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
      >

        <el-table-column :label="$t('customerService.transaction_id')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_id }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.merchant_order_id')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.merchant_order_id }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column :label="$t('customerService.payment_method')" align="center">
          <template slot-scope="scope">
            <span>{{ getPayinPaymentMethodMap( scope.row.pay_product_type) }}</span>
          </template>
        </el-table-column> -->

        <el-table-column min-width="110" :label="$t('merchant.payment_channel')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.channel_code }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column :label="$t('customerService.payment_code')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payment_switch_code ? scope.row.payment_switch_code.payment_code : '' }}</span>
          </template>
        </el-table-column> -->

        <el-table-column :label="$t('merchantAccount.transaction_status')" min-width="100" align="center">
          <template slot-scope="scope">
            <el-tag class="tag-custom" :type="getPayTransStatusType(scope.row.transaction_status)">{{ getPayTransStatusLabel(scope.row.transaction_status) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.transaction_amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchant.service_fee')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fee_split | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column :label="$t('merchant.service_fee')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payment_fee && scope.row.payment_fee.fee_split | toDivideWithDot }}</span>
          </template>
        </el-table-column> -->

        <!-- <el-table-column :label="$t('data.name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payment_info && scope.row.payment_info.payer_name }}</span>
          </template>
        </el-table-column> -->

        <!-- <el-table-column :label="$t('data.mobile')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payment_info && scope.row.payment_info.payer_mobile }}</span>
          </template>
        </el-table-column> -->

        <!-- <el-table-column :label="$t('customerService.app_name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.app_name }}</span>
          </template>
        </el-table-column> -->

        <el-table-column min-width="110" :label="$t('merchantAccount.create_time')" align="center">
          <template slot-scope="scope">
            {{ scope.row.transaction_create_time }}
          </template>
        </el-table-column>

        <el-table-column min-width="110" :label="$t('merchantAccount.complete_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_return_time }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="110" :label="$t('data.remark')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.remark }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('components.operation')" align="center" min-width="130">
          <template slot-scope="scope">

            <el-popover
              v-if="$store.getters.authorities.includes('AUTH_CODE_PAYMENT_REFUND')"
              placement="top"
              trigger="click"
            >
              <div class="text-align-center">

                <div class="operation-click-text-default" @click="onClickDetailTxt(scope.row)"> {{ $t('components.detail') }}</div>

                <el-tooltip placement="top">
                  <div slot="content">
                    <span v-if="[1,4,5,6,8,9].includes(scope.row.refund_not_support_reason)"> {{ $t('tips.refund_tip_1') }} <br> </span>
                    <span v-else-if="[2,3].includes(scope.row.refund_not_support_reason)"> {{ $t('tips.refund_tip_2') }}<br> </span>
                    <span v-else-if="[7].includes(scope.row.refund_not_support_reason)"> {{ $t('tips.refund_tip_3') }}<br> </span>
                    <span v-else> {{ $t('components.refund') }}<br> </span>
                  </div>
                  <el-button type="primary" style="width: 100%; margin: 5px 0; border: none; font-size: 14px;" size="small" plain :disabled="!(scope.row.original_refund_status && scope.row.original_refund_status !== 1) " @click="onClickRefundTxt(scope.row)">{{ $t('components.refund') }} </el-button>

                </el-tooltip>
              </div>

              <span slot="reference" style="cursor: pointer; padding: 5px">  •••
              </span>
            </el-popover>

            <template v-if="!$store.getters.authorities.includes('AUTH_CODE_PAYMENT_REFUND')">
              <el-button type="info" size="small" plain @click="onClickDetailTxt(scope.row)">
                {{ $t('components.view_details') }}
              </el-button>
            </template>

          </template>
        </el-table-column>

      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>
    <payment-details-modal ref="paymentDetailsModal" :detail-id="detailId" />
    <payment-refund-modal ref="paymentRefundModal" :detail-id="detailId" @updatelist="handleFilter" />
  </div>
</template>

<script>

import { fetchPaymentDetailInfo, fetchPaymentDetailInfoAllList } from '@/api/settlement/settlement'
import { fetchPageMethodChannelList } from '@/api/components/components'

import { payTransactionStatusMap, payTransactionStatusVoidMap, payTransactionTypeMap, payinPaymentMethodMap } from '@/utils/maps'
import { transactionSettlementStatusMap } from '@/maps/status.js'
import { filterEmptyAttr, exportXlsx } from '@/utils/common'
import { appointDate } from '@/utils/index.js'

export default {
  name: 'Pay_Trans_Details',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    PaymentDetailsModal: () => import('./Modal/PayinDetailsModal'),
    PaymentRefundModal: () => import('./Modal/PayinRefundModal')
  },
  data() {
    this.TRANSACTION_STATUS = {
      void: 4
    }
    return {
      showFilterContent: true,
      search: {
        merchant_order_id: '',
        transaction_status: null, // 交易状态
        times: [appointDate(-3) + ' 00:00:00', appointDate() + ' 23:59:59'],
        response_times: [],
        channel_code: '',
        payment_code: '',
        transaction_id: '',
        payer_mobile: '',
        app_name: ''
      },
      paymentMethodArr: [
        { label: 'Bill Payment', value: 2 },
        { label: 'QR Code', value: 1 },
        { label: 'Bank Transfer', value: 3 }
      ],
      payinChannelList: [],
      tableData: [],
      total_amount: 0,
      total_fee: 0,
      total_count: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      detailId: '',
      downloading: false
    }
  },
  computed: {
    payTransactionStatusArr() {
      // 目前只有泰国有撤销
      const payTransactionStatusArr = payTransactionStatusMap()
      const queryPayTransactionStatusVoidArr = payTransactionStatusVoidMap()
      return this.$store.getters.curCountry.country_code === 'TH' ? queryPayTransactionStatusVoidArr : payTransactionStatusArr
    },
    compFilterPaymentChannel() {
      if (!this.search.pay_product_type) {
        return this.payinChannelList
      }
      const arr = this.payinChannelList.filter(item => item.payment_method === this.search.pay_product_type)
      return arr
    },
    getPayTransStatusType() {
      return function(value) {
        return payTransactionStatusVoidMap(value).type
      }
    },
    getPayTransStatusLabel() {
      return function(value) {
        return payTransactionStatusVoidMap(value).label
      }
    },
    getPayTransTypeMap() {
      return function(val) {
        return payTransactionTypeMap(val).label
      }
    },
    getPayTransTypeStyle() {
      return function(val) {
        return payTransactionTypeMap(val).type
      }
    },
    payinPaymentMethodMap() {
      const list = payinPaymentMethodMap()
      return list.filter(item => item.value !== 1)
    },
    getPayinPaymentMethodMap() {
      return function(value) {
        return payinPaymentMethodMap(value).label
      }
    },
    transactionSettlementStatusMap() {
      return transactionSettlementStatusMap()
    }
  },
  created() {
    this.getAllChannelList()
    this.handleFilter()
  },
  methods: {
    getAllChannelList() {
      fetchPageMethodChannelList().then(res => {
        this.payinChannelList = res.data || []
      })
    },
    getPaymentDetailInfo(params) {
      this.listLoading = true
      fetchPaymentDetailInfo(params).then(res => {
        // eslint-disable-next-line no-unused-vars
        const { total = 15, list = [], current = 1, total_amount, total_fee } = res.data || {}
        this.listQuery.total = total
        this.listQuery.page = params.page ? params.page : 1
        this.tableData = list
        this.total_amount = total_amount
        this.total_fee = total_fee
        this.total_count = total
      }).finally(() => {
        this.listLoading = false
      })
    },
    getParams(otherParams = {}) {
      const { transaction_status, channel_code, times = [], response_times = [], merchant_order_id, transaction_id, payment_code, payer_mobile, app_name, ...otherSearch } = this.search
      let params = {
        start_date_time: times && times[0],
        end_date_time: times && times[1],
        response_start_date_time: response_times && response_times[0],
        response_end_date_time: response_times && response_times[1],
        transaction_status,
        channel_code,
        mch_order_id: merchant_order_id,
        transaction_id,
        payment_code,
        payer_mobile,
        app_name,
        ...otherSearch,
        ...otherParams
      }
      if (payer_mobile && ((!times || times.length === 0) && (!response_times || response_times.length === 0))) {
        this.$message.warning('Pls input Transition Date')
        return null
      }
      params = filterEmptyAttr(params)
      return params
    },

    showPayDetailModal() {
      this.$refs.paymentDetailsModal.changModalStatus(true)
    },

    handleFilter(otherParams = {}) {
      if (!this.$commonFn.checkSubmitDateLimit(this.search.times, 15)) {
        this.$message.warning('The maximum date range  is limited to 15 days, please select again')
        return
      }
      if (!this.$commonFn.checkSubmitDateLimit(this.search.response_times, 15)) {
        this.$message.warning('The maximum date range  is limited to 15 days, please select again')
        return
      }
      const params = this.getParams(otherParams)
      if (!params) {
        return
      }
      this.getPaymentDetailInfo(params)
    },

    onClickDetailTxt(row) {
      this.detailId = row.transaction_id
      this.showPayDetailModal()
    },

    onClickRefundTxt(row) {
      if ((row.original_refund_status && row.original_refund_status !== 1)) {
        this.detailId = row.transaction_id
        this.showPayRefundModal(row)
      }
    },

    showPayRefundModal(row) {
      this.$refs.paymentRefundModal.changModalStatus(true, row)
    },

    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {}
    },

    onClickDowmloadBtn() {
      if (!this.$commonFn.checkSubmitDateLimit(this.search.times, 31)) {
        this.$message.warning('The maximum date range  is limited to 31 days, please select again')
        return
      }
      if (!this.$commonFn.checkSubmitDateLimit(this.search.response_times, 31)) {
        this.$message.warning('The maximum date range  is limited to 31 days, please select again')
        return
      }
      const params = this.getParams()
      if (!params) {
        return
      }
      this.downloading = true
      fetchPaymentDetailInfoAllList(params).then(res => {
        const { data } = res
        if (!data.is_async) {
          const { list } = data
          this.handleXlsxData(list).then((downloadData) => {
            exportXlsx(downloadData, 'Pay_Trans_Details')
          })
        } else {
          this.$store.commit('app/SET_SHOW_DOWNLOAD_LIST', true)
        }
      }).finally(() => {
        setTimeout(() => {
          this.downloading = false
        }, 3000)
      })
    },

    handleXlsxData(data = []) {
      const rows = [[
        this.$t('customerService.transaction_id'),
        this.$t('merchantAccount.merchant_order_id'),
        this.$t('merchantAccount.transaction_amount'),
        this.$t('merchant.service_fee'),
        this.$t('merchantAccount.recipient_name'),
        this.$t('merchantAccount.recipient_mobile'),
        this.$t('merchantAccount.transaction_status'),
        this.$t('merchant.payment_channel'),
        // this.$t('merchantAccount.pay_trans_id'),
        this.$t('merchantAccount.create_time'),
        this.$t('merchantAccount.complete_time')
      ]]

      // const toDivideWithDot = this.$options.filters['toDivideWithDot']
      if (Array.isArray(data) && data.length > 0) {
        data.forEach((tr) => {
          rows.push([
            tr.transaction_id,
            tr.merchant_order_id,
            tr.amount,
            tr.fee,
            tr.name,
            tr.mobile,
            tr.status,
            tr.payment_channel,
            // tr.transaction_id,
            tr.create_time,
            tr.complete_time
          ])
        })
      }
      return Promise.resolve(rows)
    },
    onClickPaginator() {
      this.handleFilter(this.listQuery)
    }
  }
}
</script>

<style lang="scss" scoped>
.pay-trans-details{
  .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Poppins-Medium';
    color: #606266;
  }
  .filter-container{
    padding: 20px 0 0 20px;
  }
  .search-frame {
    width: 230px;
    margin-right: 5px;
  }
  .search-frame-order{
    width:200px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
  .picker{
    width: 230px
  }
  .mb-10{
    margin-bottom: 10px;
  }
  .detailTxt{
    font-size: 12px;
    color: #3579FF;
    text-decoration: underline;
     cursor: pointer;
  }
  .total-container{
    display: flex;

    margin-bottom: 48px;
    .total-item{
      padding: 24px;
      flex: 1;
      font-weight: 400;
      font-size: 14px;
      color: #4B5567;
      border: 1px solid rgba(54, 66, 80, 0.20);
      border-radius: 8px;
      .total-item-text{
        margin-bottom: 12px;
      }
      .total-item-num{
        font-size: 24px;
        font-weight: 600;
      }
    }
    .total-item:not(:last-child){
      margin-right: 24px;
    }
  }
  .total{
    border-top: 1px solid #D5D8DE;
    padding: 24px 24px 0 24px;
    &-title{
      font-size: 12px;
      line-height: 17px;
      color: #606266;
    }
    &-num{
      margin-top: 10px;
      padding-bottom: 20px;
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      line-height: 24px;
      color: #303133;
    }
  }
}

</style>
